import React, { useRef } from 'react'
import { Elevator } from 'lib'
import useTimeline from 'hooks/useTimeline'

const Parallax = ({ distance = 10, children }) => {
  const childrenRef = useRef()

  const parallaxTL = useTimeline(
    { paused: true, restoreTime: true },
    (tl) => {
      tl.fromTo(
        childrenRef.current,
        {
          yPercent: distance,
          force3D: true,
          perspective: 1,
        },
        {
          yPercent: -distance,
          force3D: true,
          perspective: 1,
          ease: 'none',
        }
      )
    },
    [childrenRef, distance]
  )

  return (
    <Elevator tl={parallaxTL} easing={0.2}>
      {children(childrenRef)}
    </Elevator>
  )
}

export default Parallax
